// pdVideosArray Copyright 2022-2024 Rebecca L Beaudet
import { CORP_NAME, FOUNDER } from './constantContent';
const intro = `In this educational video for parents, caregivers, and professionals, ${FOUNDER}, founder of ${CORP_NAME},`;
const portalImages = '/img/learning_portal_img/';
// NOTE the title is the key to look up existing product DO NOT CHANGE
const pdVideosListJson = [
    {
        title: 'Neurodiversity and Shifting Our Language',
        description: `${intro} defines neurodiversity and 
    dives into person affirming language under the Human Rights Model of Disability.`,
        id: 0,
        thumbnail: `${portalImages}Neurodiversity Thumbnail.jpg`,
        thumbnailDesc: `A rainbow infinity symbol on a black canvas`,
        link: '',
        selected: false,
        price: 1099,
    },
    {
        title: `Play: What is it? Why is it important? How do we support it?`,
        description: `${intro} defines play and dives into why play is important for children and 
    how adults can support a child's development and learning through play.`,
        id: 1,
        thumbnail: `${portalImages}Play Thumbnail.jpg`,
        thumbnailDesc: `Toys, including a brown teddy bear, stacked blocks, ring stackers and rubik's cube, on a black canvas`,
        link: '',
        selected: false,
        price: 1099,
    },
    {
        title: `Talking to Your Child About Autism`,
        description: `${intro} discusses why it is important to tell children they are Autistic, 
    how to prepare for the conversation, and what to say when you have the conversation.`,
        id: 2,
        thumbnail: `${portalImages}Autism Thumbnail.jpg`,
        thumbnailDesc: `Gold infinity symbol on a black canvas`,
        link: '',
        selected: false,
        price: 1099,
    },
    {
        title: `Sensory Differences & How to Support Them`,
        description: `
    ${intro} defines the eight sensory systems and dives into why co-regulation is important and 
    how we can change the environment to support all learners.`,
        id: 3,
        thumbnail: `${portalImages}Sensory Thumbnail.jpg`,
        thumbnailDesc: `white outline of a person with three surrounding boxes 
      which have radiating symbols directed to and from the person on a black canvas`,
        link: '',
        selected: false,
        price: 1299,
    },
    {
        title: `Sexual Education and Disability`,
        description: `
    ${intro} discusses sexual education and puberty and how to support disabled and 
    neurodivergent individuals during this transition in a safe and respectful way.`,
        id: 4,
        thumbnail: `${portalImages}Sex Ed Thumbnail.jpg`,
        thumbnailDesc: `Stacked blue, yellow, and green books on a black canvas`,
        link: '',
        selected: false,
        price: 1499,
    },
    {
        title: `Everything IEP: A "Crash Course"`,
        description: `
    ${intro} discusses components of a New Hampshire-based IEP as well as parent and 
    guardian rights during the IEP and Placement process.`,
        id: 5,
        thumbnail: `${portalImages}IEP Thumbnail.jpg`,
        thumbnailDesc: `Red, yellow, and blue wooden letter blocks that spell out IEP on a black canvas`,
        link: '',
        selected: false,
        price: 1699,
    },
    {
        title: `Reinforcement: Does it Harm Kids? Part 1`,
        description: `${intro} discusses functions of behavior, foundations of learning, and how reinforcement harms kids.`,
        id: 6,
        thumbnail: `${portalImages}Reinforcement Thumbnail.jpg`,
        thumbnailDesc: 'A yellow star on a black background',
        link: '',
        selected: false,
        price: 1499,
    },
    {
        title: `Reinforcement: Moving Beyond Extrinsic Systems. Part 2`,
        description: `${intro} reviews the harms of extrinsic systems and details ways to move beyond them through building intrinsic motivation, focusing on connection, supporting communication,  promoting co-regulation, collaborating with others, and offering true choice.`,
        id: 7,
        thumbnail: `${portalImages}Extrinsic Systems Thumbnail.jpg`,
        thumbnailDesc: 'A yellow star on a black background',
        link: '',
        selected: false,
        price: 1499,
    },
];
export { pdVideosListJson };
